import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import ps from '../../s.module.less';
import TransferSubmittedImg from 'assets/efax/efax-transfer-submitted.png';
import { Email } from 'constants/contact';

type Props = {
    transferNumber: string;
    /**
     * Optional hook so parent can re-check whether a fax number
     * has become available after submission.
     * When omitted, the "Refresh status" button is hidden.
     */
    onSetUpComplete?: () => void;
};

const TransferSubmitted = ({ transferNumber, onSetUpComplete }: Props) => {
    return (
        <div className={s.wrap}>
            <div className={s.card}>
                <div className={s.imageWrap}>
                    <img className={s.image} src={TransferSubmittedImg} alt="" aria-hidden="true" />
                </div>

                <div className={s.header}>
                    <div className={ps.headerTitle}>Transfer request submitted</div>
                    <div className={ps.headerDesc}>
                        Your fax number <span className={s.number}>{transferNumber}</span>
                        {"'s"} transfer is now in progress.
                    </div>
                </div>

                <div className={s.nextCard}>
                    <div className={s.nextText}>
                        <strong>What happens next:</strong>
                        <ol className={s.nextList}>
                            <li>{"We'll submit the request to your current provider"}</li>
                            <li>They must approve the release</li>
                            <li>{"We'll notify you once the number is ready"}</li>
                        </ol>
                        {'\u23F3'} Estimated timeline: 1{'\u20132'} months.
                    </div>
                </div>

                <div className={s.supportText}>
                    Have a question about the transfer? Contact{' '}
                    <a href={`mailto:${Email.klarity_provider_support}`} className={s.supportLink}>
                        Klarity support team
                    </a>
                    .
                </div>
            </div>

            {onSetUpComplete && (
                <div className={s.actions}>
                    <Button type="primary" className={ps.actionBtn} onClick={() => onSetUpComplete()}>
                        Refresh status
                    </Button>
                </div>
            )}
        </div>
    );
};

export default TransferSubmitted;
